import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryLedgerPage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/ledger')({
  component: () => (
    <RequirePermission permission='inventory_ledger.read'>
      <InventoryLedgerPage />
    </RequirePermission>
  ),
})
